import { motion, useReducedMotion } from 'framer-motion';
import React from 'react';

interface RevealProps {
    className?: string;
    delay?: number;
    /** Distance travelled on entry, in px. */
    y?: number;
    as?: 'div' | 'li' | 'section';
}

/**
 * Entry animation used across sections. Collapses to a plain fade when the
 * visitor prefers reduced motion.
 */
export default function Reveal({ children, className, delay = 0, y = 24, as = 'div' }: React.PropsWithChildren<RevealProps>) {
    const reduced = useReducedMotion();
    const Component = motion[as];

    return (
        <Component
            className={className}
            initial={{ opacity: 0, y: reduced ? 0 : y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-10% 0px -10% 0px' }}
            transition={{ duration: reduced ? 0.2 : 0.6, delay: reduced ? 0 : delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </Component>
    );
}
